import React, { useEffect, useState } from 'react';
import { wt } from '../i18n';
import { useLanguage } from '../../src/functions/useLanguage';
import { websitePath } from '../lib/routes';

const STORAGE_KEY = 'kodacare_cookie_consent';

export function CookieConsent() {
  const { language } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(STORAGE_KEY, 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      className="fixed bottom-0 inset-x-0 z-50 bg-white border-t border-gray-200 shadow-xl px-4 py-5 sm:px-6"
    >
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row sm:items-center gap-4">
        {/* Icon + text */}
        <div className="flex items-start gap-3 flex-1">
          <span className="text-2xl flex-shrink-0 mt-0.5">🍪</span>
          <div>
            <p className="text-sm font-semibold text-gray-800 mb-1">
              {wt(language, 'gdpr.title')}
            </p>
            <p className="text-xs text-gray-500 leading-relaxed">
              {wt(language, 'gdpr.body')}{' '}
              <a
                href={websitePath('/privacy')}
                className="underline text-primary-brown hover:text-primary-brown/80 transition-colors"
              >
                {wt(language, 'gdpr.learnMore')}
              </a>
              .
            </p>
          </div>
        </div>

        {/* Buttons */}
        <div className="flex items-center gap-3 sm:flex-shrink-0">
          <button
            onClick={decline}
            className="text-xs text-gray-500 hover:text-gray-700 underline transition-colors"
          >
            {wt(language, 'gdpr.decline')}
          </button>
          <button
            onClick={accept}
            className="px-5 py-2 rounded-full bg-primary-brown hover:bg-primary-brown/80 text-white text-xs font-semibold transition-colors"
          >
            {wt(language, 'gdpr.accept')}
          </button>
        </div>
      </div>
    </div>
  );
}
